import { QuestionGroup } from "./question-group.model";
import { ReferralForm } from "./referral-form.model";
import { IReferralFormQuestionGroup } from "./interfaces/referral-form-question-group";

export class ReferralFormQuestionGroup implements IReferralFormQuestionGroup {
  isDeleted: boolean;
  index: number;
  referralFormId: number;
  questionGroupId: number;
  referralForm: ReferralForm;
  questionGroup: QuestionGroup;

  prepare(): void {
      if (this.index < 1) {
        this.index = 1;
      }

    this.referralForm.prepare();
    this.questionGroup.prepare();
  }

  isValid(): boolean {
    return this.index > 0
      && this.questionGroupId > -1
      && this.referralFormId > -1
      && this.referralForm
      && this.referralForm.isValid()
      && this.questionGroup
      && this.questionGroup.isValid();
  }
}
